import { render, staticRenderFns } from "./Geography.vue?vue&type=template&id=e7625cb4&"
import script from "./Geography.vue?vue&type=script&lang=js&"
export * from "./Geography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports